import { ReactElement, ReactNode } from 'react';
import styles from './OrderConfirmation.module.scss';

interface WhatToKnowSection {
  title: string;
  body?: ReactNode;
  icon?: ReactNode;
}

interface WhatToKnowProps {
  sections: WhatToKnowSection[];
  header?: string;
  isVertical?: boolean;
  useSmallSizing?: boolean;
}

export function WhatToKnow({
  sections,
  header,
  isVertical = false,
  useSmallSizing = false,
}: WhatToKnowProps): ReactElement {
  const headerStyle = useSmallSizing ? {
    fontSize: '16px',
    lineHeight: '22px',
  } : {};
  const sectionsStyle = isVertical ? {
    flexDirection: 'column' as const,
    gap: '0px',
  } : {};

  return (
    <div className={styles.what_to_know}>
      <div className={styles.what_to_know_content}>
        <h2 className={styles.header} style={headerStyle}>
          {header ?? 'What to expect'}
        </h2>

        <hr className={styles.divider} />

        <div className={styles.what_to_know_sections} style={sectionsStyle}>
          {sections.map((section) => {
            const sectionStyle = isVertical ? {
              flexDirection: 'row' as const,
              alignItems: 'flex-start' as const,
              gap: section.body ? '32px' : '0px',
            } : {};
            const iconStyle = useSmallSizing ? { margin: section.body ? '14px 0 0 0' : '0px' } : {};
            const titleStyle = useSmallSizing ? (section.body ? {
              fontSize: '14px',
              lineHeight: '18px',
              margin: '10px 0 0 0',
              fontWeight: 500,
            } : {
              fontFamily: 'Open Sans',
              fontWeight: 400,
              fontStyle: 'normal',
              fontSize: '12px',
              letterSpacing: '0px',
              verticalAlign: 'bottom',
              margin: '0px',
            }) : {};

            return (
              <div key={section.title} className={styles.what_to_know_section} style={sectionStyle}>
                {section.icon && (
                  <div className={styles.what_to_know_section_icon} style={iconStyle}>
                    {section.icon}
                  </div>
                )}
                <div className={styles.what_to_know_section_text}>
                  <h3 className={styles.what_to_know_section_title} style={titleStyle}>
                    {section.title}
                  </h3>
                  {section.body && (
                    <p
                      className={styles.what_to_know_section_body}
                      style={useSmallSizing ? { fontSize: '12px' } : {}}
                    >
                      {section.body}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
